import { render } from "./analysis1.vue?vue&type=template&id=afdc3c6a&scoped=true"
import script from "./analysis1.vue?vue&type=script&lang=js"
export * from "./analysis1.vue?vue&type=script&lang=js"

import "./analysis1.vue?vue&type=style&index=0&id=afdc3c6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdc3c6a"]])

export default __exports__